const JOB_STATES = {
    IDLE: 'idle',
    STARTED: 'started',
    COMPLETED: 'completed',
    READY:'ready',
    FAILED: 'failed',
}

module.exports = JOB_STATES